module.exports = __webpack_public_path__ + "static/media/sadReaction.2b52f9e7.svg";